import { PlaybookTask, PlaybookTaskAction } from '@driftt/api-types'

import { ConversationAPI } from 'api'

export const createTask = (task: PlaybookTask, playbookId: number) =>
  ConversationAPI.post<PlaybookTask>('/task', {
    ...task,
    playbookId: playbookId,
  })

export const updateTask = (
  task: PlaybookTask,
  playbookId: string,
  taskId: PlaybookTaskAction
) =>
  ConversationAPI.patch<PlaybookTask>(`/task/${playbookId}/${taskId}`, {
    ...task,
    playbookId,
  })

export const getTasksForPlaybook = (playbookId: string) =>
  ConversationAPI.get<PlaybookTask>(`/task/${playbookId}`, {
    params: {
      action: 'DISABLE',
    },
  })

export const deleteTask = (playbookId: string, taskId: PlaybookTaskAction) =>
  ConversationAPI.delete(`task/${playbookId}/${taskId}`)

export const getTasks = (playbookIds: number[]) =>
  ConversationAPI.get<Record<number, PlaybookTask[]>>(`/task`, {
    params: {
      action: 'DISABLE',
      playbookId: playbookIds,
    },
  })
